// ┌─────────────────────────────────────────────────────────────────────────┐
// │ Formularis de Sherpa — llistat i definició (única via de selecció).        │
// └─────────────────────────────────────────────────────────────────────────┘
//
// Parla el patró RPC REAL de Sherpa (com `programService.js` / vue-dashboard):
//   POST {baseURL}/{ts}/{area}/{bloc}/{op}  amb cos { requestHeader, requestContent }
// (s'ha eliminat el dialecte REST fictici /forms que no existia al backend).
//
// Endpoints (FileTransformProcess, àrea filetransform):
//   · /filetransform/formlist/task       → llista de formularis ACTIUS de Sherpa (view_form)
//   · /filetransform/formdefinition/task → definició de camps d'un formulari (per questId)
// En standalone, la connexió (baseUrl + token) ve de la barra de Configuració
// (SettingsPanel → runtimeConfig), igual que vue-dashboard.
import sherpaClient from './sherpaClient.js';
import { getRuntimeConfig, effectiveBaseUrl } from '@vft/config/runtimeConfig.js';

function getHost() {
  try {
    return new URL(effectiveBaseUrl(getRuntimeConfig())).origin;
  } catch {
    return '';
  }
}

// Capçalera estàndard de Sherpa (mateixa forma que programService.buildHeader).
function buildHeader(refererPath = '/file-transform/file-transform-management/file-transform-tool') {
  const host = getHost();
  const cfg = getRuntimeConfig();
  const lang = (cfg.lang || 'ca_ES').toLowerCase();
  return {
    acceptLanguage: 'ca-ES',
    externalReferer: `${host}/login`,
    lang,
    referer: `${host}${refererPath}`,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    product: 'Gecko',
    platform: 'Win32',
    vendor: 'Google Inc.',
    token: null,
    version: null,
  };
}

// Llista els formularis ACTIUS de Sherpa: [{ id, name, family, category, responses }].
export async function listForms() {
  const ts = Date.now();
  const payload = {
    requestHeader: buildHeader(),
    requestContent: { jsonData: {} },
  };
  const { data } = await sherpaClient.post(`${ts}/filetransform/formlist/task`, payload);
  return Array.isArray(data) ? data : [];
}

// Definició de camps d'un formulari EN UN IDIOMA (mateix shape que el parser XLSX):
//   [{ id(alias), label, type, validation:{ mandatory:{required,min,max}, format:{lengthMin,lengthMax,regExp}, domain:[{key,value}] } }]
// `lang` és l'idioma de càrrega triat (un dels que retorna listForms per al form).
export async function getFormDefinition(formId, lang) {
  const ts = Date.now();
  const payload = {
    requestHeader: buildHeader(),
    requestContent: { jsonData: lang ? { questId: formId, lang } : formId },
  };
  const { data } = await sherpaClient.post(`${ts}/filetransform/formdefinition/task`, payload);
  return Array.isArray(data) ? data : [];
}
